import { ReactNode } from 'react';
import { Container, Navbar } from 'react-bootstrap';

import { Layout } from '@shared';
import { monserratSemiBold, robotoRegular } from '@habitech/shared';
import { SidebarOrchestrator } from '../SidebarOrchestrator/SidebarOrchestrator';
import {
  StatusCards,
  SearchOrchestratorPricingCommittee,
  ProcessFilterDropdown,
  ProcessStatusFilterDropdown,
  OrchestratorNidsClipBoard,
  AliasFilterDropdown,
  SortByDateButton,
  StartDateFilter,
  EndDateFilter,
} from '@domains/orchestrator-pricing-committee';

interface OrchestratorPricingCommitteeLayoutProps {
  title: string;
  children: ReactNode;
}

export const OrchestratorPricingCommitteeLayout = ({
  title,
  children,
}: OrchestratorPricingCommitteeLayoutProps) => (
  <Layout>
    <SidebarOrchestrator />
    <Container fluid className="w-100 py-3 px-0 h-100">
      <Navbar className="pt-0">
        <Container fluid className="px-3">
          <div style={{ fontFamily: monserratSemiBold, fontSize: '20px' }}>
            {title}
          </div>
          <div
            className="d-flex justify-content-end"
            style={{ fontFamily: robotoRegular }}
          >
            <div className="me-2">
              <OrchestratorNidsClipBoard />
            </div>
            <div className="me-2">
              <AliasFilterDropdown />
            </div>
            <div className="me-2">
              <ProcessFilterDropdown />
            </div>
            <div className="me-2">
              <ProcessStatusFilterDropdown />
            </div>
            <div className="me-2">
              <StartDateFilter />
            </div>
            <div className="me-2">
              <EndDateFilter />
            </div>
            <div className="me-2">
              <SortByDateButton />
            </div>
            <SearchOrchestratorPricingCommittee />
          </div>
        </Container>
      </Navbar>
      <div className="px-3">
        <StatusCards />
      </div>
      <div
        className="px-3"
        style={{
          flex: '1 1 auto',
          overflowY: 'auto',
          height: 'calc(100% - 140px)',
        }}
      >
        {children}
      </div>
    </Container>
  </Layout>
);

